export const SIDEBAR_PROFILE_CACHE_DURATION = 300000;

export function loadCachedProfile(cacheKey, timestampKey, onProfileLoaded) {
  try {
    const cachedData = localStorage.getItem(cacheKey);
    const cachedTimestamp = localStorage.getItem(timestampKey);
    if (cachedData && cachedTimestamp) {
      const cacheAge = Date.now() - parseInt(cachedTimestamp, 10);
      if (cacheAge < SIDEBAR_PROFILE_CACHE_DURATION) {
        onProfileLoaded(JSON.parse(cachedData));
        return true;
      }
    }
  } catch (error) {
    console.error('Error loading cached profile:', error);
    localStorage.removeItem(cacheKey);
    localStorage.removeItem(timestampKey);
  }
  return false;
}

export function clearSidebarProfileCache(cacheKey, timestampKey) {
  localStorage.removeItem(cacheKey);
  localStorage.removeItem(timestampKey);
}
